import { Devis } from '@/models/Devis';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { DEVIS } from './mutation-types';
import { initialState as resetState, SuiviDevisState } from './state';

export const mutations: MutationTree<SuiviDevisState> = {
    [DEVIS.SET_ITEMS](state, items: Devis[]) {
        state.devis = items;
    },
    [DEVIS.RESET_ITEMS](state) {
        state.page = 0;
        state.devis = [];
        state.count = 0;
    },
    [DEVIS.ADD_ITEMS](state, items: Devis[]) {
        state.devis = [...state.devis, ...items];
    },
    [DEVIS.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [DEVIS.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [DEVIS.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [DEVIS.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [DEVIS.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [DEVIS.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [DEVIS.REMOVE_FILTER_SITE](state, site: number) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [DEVIS.SET_FILTER_SITE](state, siteList: number[]) {
        state.filterSite = siteList;
    },
    [DEVIS.ADD_FILTER_STATUS](state, status: string) {
        state.filterStatus = [...state.filterStatus, status];
    },
    [DEVIS.REMOVE_FILTER_STATUS](state, status: string) {
        state.filterStatus = state.filterStatus.filter(x => x !== status);
    },
    [DEVIS.SET_FILTER_STATUS](state, statusList: string[]) {
        state.filterStatus = statusList;
    },
    [DEVIS.SET_FILTER_DEVIS_ID](state, id: string) {
        state.filterDevisId = id;
    },
    [DEVIS.SET_FILTER_DEVIS_NUMERO_COMMANDE](state, id: string) {
        state.filterNumero = id;
    },
    [DEVIS.SET_FILTER_DEVIS_NUM_FACTURE](state, id: string) {
        state.filterNumFactures = id;
    },
    [DEVIS.SET_FILTER_DATE_DEBUT](state, value: string) {
        state.filterDateDebut = value;
    },
    [DEVIS.SET_FILTER_DATE_FIN](state, value: string) {
        state.filterDateFin = value;
    },
    [DEVIS.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [DEVIS.SET_ERROR](state, error: Error) {
        state.error = error;
    },
    [DEVIS.CLEAR_ALL](state) {
        Object.assign(state, resetState);
    },
    [DEVIS.ADD_BONCOMMANDE](state, file: File) {
        if (file.type === 'application/pdf') {
            state.bonDeCommandeFile.splice(0, 1);
            state.bonDeCommandeFile.push(file);
        }
    },
    [DEVIS.REMOVE_BONCOMMANDE](state) {
        state.bonDeCommandeFile.splice(0, 1);
    },
    [DEVIS.SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.isExportXlsLoading = isLoading;
    },
    [DEVIS.SET_SCROLL_INTERVENTIONS](state, scroll: number) {
        state.scrollInterventions = scroll;
    },

    [DEVIS.SET_SORT_INTERVENTIONS](state, sort) {
        state.tableHeaderInterventions = state.tableHeaderInterventions.map(header => {
            if (header.sortData !== sort.sortData) {
                if (header.sortStatus !== SortType.INACTIVE) {
                    header.sortStatus = SortType.NONE;
                }
            } else {
                header.sortStatus = sort.sortStatus;
            }

            return header;
        });

        state.sortInterventions = sort;
    },
    [DEVIS.RESET_ITEMS_INTERVENTIONS](state) {
        state.interventions = [];
        state.pageInterventions = 0;
        state.countInterventions = 0;
    },
    [DEVIS.SET_ITEMS_INTERVENTIONS](state, items) {
        state.interventions = items;
    },

    [DEVIS.ADD_ITEMS_INTERVENTIONS](state, items) {
        state.interventions = [...state.interventions, ...items];
    },

    [DEVIS.SET_PAGE_INTERVENTIONS](state, page: number) {
        state.pageInterventions = page;
    },

    [DEVIS.SET_NB_OF_PAGES_INTERVENTIONS](state, pages: number) {
        state.nbOfPagesInterventions = pages;
    },

    [DEVIS.SET_IS_LOADING_INTERVENTIONS](state, isLoading: boolean) {
        state.isLoadingInterventions = isLoading;
    },

    [DEVIS.SET_ERROR_INTERVENTIONS](state, error: Error | undefined) {
        state.errorInterventions = error;
    },

    [DEVIS.SET_COUNT_INTERVENTIONS](state, count: number) {
        state.countInterventions = count;
    },
};
